export const ADMIN_TABS = [
  "customers",
  "analytics",
  "deleted-orders",
  "expenses",
];

export const PUBLIC_NAV_ITEMS = [
  { key: "orders", label: "Orders", icon: "📦" },
  { key: "buffet-bookings", label: "Buffet Bookings", icon: "🍽" },
  // { key: "reservations", label: "Reservations", icon: "📅" },
  { key: "hall-rentals", label: "Hall Rentals", icon: "🏛" },
  { key: "calendar", label: "Calendar", icon: "📅" },
  { key: "documents", label: "Documents", icon: "📁" },
  { key: "items", label: "Instock Items", icon: "📋" },
  { key: "outofstock", label: "Sold Out", icon: "⚠️" },
  { key: "categories", label: "Categories", icon: "🗂" },
  { key: "inventory", label: "Inventory", icon: "🗄️" },
];

export const ADMIN_NAV_ITEMS = [
  { key: "customers", label: "Customers", icon: "👥" },
  { key: "analytics", label: "Analytics", icon: "📊" },
  { key: "deleted-orders", label: "Cancelled Orders", icon: "🗑" },
  { key: "expenses", label: "Expenses", icon: "💰" },
];